module.exports = __webpack_public_path__ + "baby_pretty-pastel-floral_1.jpg";